import { formatDay } from '@/lib/relativeTime';
import type { EveryoneFeedItem, FriendProgress } from '@/types/referral';

/**
 * Whether a friend can still finish the deal: unpaid, not rejected or
 * expired, and still on the ambassador's list. The one rule behind the
 * row's NUDGE pill, the sheet's Text button and the nudge screen's
 * recipient list — it used to live in all three, slightly differently.
 * Phone and platform checks layer on top where a text is actually sent.
 */
export function canStillFinish(item: EveryoneFeedItem): boolean {
  return item.stage === 'in_progress' && !item.hidden && item.progress?.tone !== 'failed';
}

/**
 * What the friend last did and the day it happened, as one line:
 * "Opened SoFi Sep 11". Dated by that step's own confirmation, else by
 * the payout / failure / signup. Line 3 of the row, and the sheet's
 * identity line and status card, all print exactly this.
 */
export function stepLineFor(progress: FriendProgress, now = Date.now()): string {
  const day = formatDay(progress.step_at ?? progress.last_update_at ?? '', now);
  return [progress.step_label, day].filter(Boolean).join(' ');
}
